module.exports = __webpack_public_path__ + "static/media/canadaposticon.60fd9274.svg";